import { RootState } from "@/modules/common";

export const selectDeliveryCosts = (state: RootState) =>
  state.basket.basket.products.find(
    product => product.id === "410d3ef3-a07e-4dff-b2e6-df04747b47e5"
  );
